<template>
    <ion-content>
        <img src="@/assets/nimtu_medium.png" style="padding: .5em 7em;" />
        <ion-card v-for="deal of deals" :key="deal.id" class="card">
            <router-link :to="{name: 'deal', params: { id: deal.id }}">
            <img :src="deal.pic" />
            <div class="triangle"><font-awesome-icon :icon="deal.type == 'flight' ? 'plane-departure' : 'suitcase'" class="type"></font-awesome-icon></div>
            <div class="time"><font-awesome-icon icon="clock" /> {{deal.when}}</div>
            <ion-card-header>
                <ion-grid>
                    <ion-row>
                        <ion-col size="9" class="title">
                            {{deal.title}}
                        </ion-col>
                        <ion-col class="price" v-if="deal.currency == '$'">
                            {{deal.currency}}{{deal.cost}}
                        </ion-col>
                        <ion-col class="price" v-else>
                            {{deal.cost}} {{deal.currency}}
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-card-header>

            <ion-card-content class="tags">
                <ion-chip outline="true" color="primary" v-for="tag of deal.tags" :key="tag">{{tag}}</ion-chip>
            </ion-card-content>
            </router-link>
        </ion-card>
    </ion-content>
</template>

<script>
export default {
  name: 'DealSummary',
  props: {
    deals: Array,
  },
};
</script>

<style scoped>
ion-icon {
    z-index: 99;
}

ion-card-header {
    padding: .5em;
}

ion-badge {
    margin-right: 10px;
    --padding-start: 10px;
    --padding-bottom: 10px;
    --padding-top: 10px;
    --padding-end: 10px;
}
.triangle {
  position: absolute;
  top: -3em;
  left: -3em;
  width: 6em;
  height: 6em;
  transform: rotate(45deg);
  background: #f05;
}

.triangle .type {
    top: 1.9em;
    left: 1.4em;
    position: relative;
    font-size: 1.2em;
    transform: rotate(315deg);
}

.card {
    position: relative;
}

.card a {
    text-decoration: none;
    color: #fff;
}

.title {
    text-align: left;
    font-size: calc(1.4em + 1vw);
    color: #444;
    font-weight: bold;
}

.price {
    text-align: right;
    font-size: calc(1.4em + 1vw);
    font-weight: bold;
}

.time {
    position: absolute;
    z-index: 99;
    top: 0;
    right: 0;
    padding: 1em;
    font-weight: bold;
}

.tags {
    text-align: left;
}
</style>
